var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"Required field"}},[_vm._v("\n  ("),_c('font-awesome-icon',{staticClass:"text-danger font-weight-bold",attrs:{"icon":['fas', 'asterisk'],"size":"sm"}}),_vm._v(")\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }